<template>
    <section>
        <div class="columns box">
            <div class="column is-5">
                <b-field>
                    <b-input :placeholder="$t('PORTALESTOQUE.PESQUISAR')"
                             v-model="procurar"
                             icon="magnify"
                             @input="loadAsyncData"></b-input>
                </b-field>
            </div>
            <div class="column">
                <div class="buttons">
                    <router-link :to="{ name: 'portalpedido' }" class="button is-primary">
                        {{$t('PORTALESTOQUE.INCLUIR')}}
                    </router-link>
                </div>
            </div>
            <div class="column is-2">
                <form @submit.prevent="abrirCadastroInput">
                    <b-field>
                        <b-input :placeholder="$t('PORTALESTOQUE.CODIGO')"
                                 v-model="id"
                                 type="number"
                                 icon-right="edit"
                                 icon-right-clickable
                                 @icon-right-click="abrirCadastroInput">
                        </b-input>
                    </b-field>
                </form>
            </div>
        </div>
        <b-table :data="model.lista"
                 :loading="loading"
                 paginated
                 striped
                 hoverable
                 backend-pagination
                 :total="total"
                 @page-change="onPageChange"
                 :aria-next-label="$t('PORTALESTOQUE.PROXPAGINA')"
                 :aria-previous-label="$t('PORTALESTOQUE.PAGANTERIOR')"
                 :aria-page-label="$t('PORTALESTOQUE.PAGINA')"
                 :aria-current-label="$t('PORTALESTOQUE.PAGATUAL')"
                 backend-sorting
                 :default-sort-direction="defaultOrdenar"
                 :default-sort="[ordenarPor, ordenar]"
                 sort-icon-size="is-small"
                 @sort="onSort">

            <template @click="abrirCadastro(props.row.id)">
                <b-table-column  v-slot="props" field="Id" :label="$t('PORTALESTOQUE.CODIGO')" sortable>
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column  v-slot="props" field="Referencia" :label="$t('PORTALESTOQUE.REFERENCIA')" sortable>
                    {{ props.row.referencia }}
                </b-table-column>

                <b-table-column  v-slot="props" field="Data" :label="$t('PORTALESTOQUE.DATA')" sortable>
                    {{ $moment(props.row.data).format("DD/MM/YYYY") }}
                </b-table-column>

                <b-table-column  v-slot="props" :label="$t('PORTALESTOQUE.STATUS')">
                    <span v-if="props.row.status == 'Aguardando'" class="tag is-warning">
                        {{ props.row.status }}
                    </span>
                    <span v-if="props.row.status == 'Cancelado'" class="tag is-danger">
                        {{ props.row.status }}
                    </span>
                    <span v-if="props.row.status == 'Planejado'" class="tag is-info">
                        {{ props.row.status }}
                    </span>
                    <span v-if="props.row.status == 'Entregue'" class="tag is-success">
                        {{ props.row.status }}
                    </span>
                    <span v-if="props.row.status == 'Enviado'" class="tag is-default">
                        {{ props.row.status }}
                    </span>
                    <span v-if="props.row.status == 'Recebido'" class="tag is-primary">
                        {{ props.row.status }}
                    </span>
                </b-table-column>

                <b-table-column  v-slot="props" custom-key="actions" numeric>
                    <router-link :to="{ name: 'portalpedido', params: { pedidoId: props.row.id }}" class="button is-small is-primary" :title="$t('PORTALESTOQUE.EDITAR')">
                        <b-icon icon="pencil" size="is-small"></b-icon>
                    </router-link>
                </b-table-column>
            </template>
        </b-table>
    </section>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        data() {
            return {
                datas: [
                    this.$moment().subtract(30, 'days').toDate(),
                    this.$moment().toDate()
                ],
                model: [],
                total: 0,
                loading: false,
                procurar: this.$route.query.procurar ?? "",
                procurarStatus: this.$route.query.procurarStatus ?? 0,
                ordenarPor: 'Referencia',
                ordenar: 'asc',
                defaultOrdenar: 'asc',
                page: 1,
                perPage: 20,
                selecionado: null,
                id: null
            }
        },
        computed: {
            ...mapGetters([
                'isInRole'
            ])
        },
        methods: {
           loadAsyncData() {
                const params = [
                    `procurar=${this.procurar}`,
                    `ordem=${this.ordenarPor}.${this.ordenar}`,
                    `page=${this.page}`,
                    `perPage=${this.perPage}`
                ].join('&')

                this.loading = true
                this.$http.get(`/api/portal/pedidos?${params}`)
                    .then(({ data }) => {
                        this.model = data;
                        this.total = this.perPage * data.pageCount
                        this.loading = false
                    })
                    .catch((error) => {
                        this.model = []
                        this.total = 0
                        this.loading = false
                        throw error
                    })
            },
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            onSort(field, order) {
                this.ordenarPor = field
                this.ordenar = order
                this.loadAsyncData()
            },
            abrirCadastroInput() {
                this.$router.push({ path: `/portal/pedido/${this.id}` })
            },
        },
        mounted() {
            this.loadAsyncData()
        }
    }
</script>